
import { useTextGeneration } from '@/hooks/text-generation';
import { useCallback } from 'react';

export const useAppIdeaTextGeneration = () => {
  const { generateText } = useTextGeneration();

  const generateTitle = useCallback(async (problemStatement: string) => {
    return generateText({
      message: problemStatement,
      type: 'app_title_generation',
    });
  }, [generateText]);

  const generateDescription = useCallback(async (problemStatement: string) => {
    return generateText({
      message: problemStatement,
      type: 'app_description_generation',
    });
  }, [generateText]);

  return { generateTitle, generateDescription };
};
